// extracted by mini-css-extract-plugin
export default {"link":"nav_link__yoJd8","active":"nav_active__QMB2z"};